import gql from 'graphql-tag';

export const getVotingQuestionsWithAnswers = gql`
  query ($voting: Int) {
    getVotingQuestions(voting: $voting) {
      votingQuestionId
	    question
	    multipleChoice
	    choices
    }
  }
`
